import { FormItem } from "./createDownline.models";

export enum FormItemType {
    TEXT = "text",
    EMAIL = "email",
    TEL = "tel",
    URL = "url",
    SELECT = "select",
}

export enum CreateDownlineRequestFields {
    FIRST_NAME = "firstName",
    LAST_NAME = "lastName",
    PRIMARY_PHONE = "primaryPhoneNumber",
    CELL_PHONE = "secondaryPhoneNumber",
    EMAIL = "email",
    AGENCY_NAME = "agencyName",
    WEBSITE = "subDomain",
    USER_TYPE = "userTypeId",
    PRODUCT_UID = "proUid",
    COMMISSION_UID = "commissionUid",
    WRITING_NUMBER = "agentWritingNumber",
    AGENCY_NUMBER = "agencyNumber",
    PARENT_USER_ID = "parentUserId",
}

export const PERSONAL_INFORMATION_FORM_ITEMS: FormItem[] = [
    {
        field: CreateDownlineRequestFields.FIRST_NAME,
        label: "First Name",
        type: FormItemType.TEXT,
        placeholder: "Enter First Name",
    },
    {
        field: CreateDownlineRequestFields.LAST_NAME,
        label: "Last Name",
        type: FormItemType.TEXT,
        placeholder: "Enter Last Name",
    },
    {
        field: CreateDownlineRequestFields.PRIMARY_PHONE,
        label: "Primary Phone",
        type: FormItemType.TEL,
        placeholder: "Enter Primary Phone No",
    },
    {
        field: CreateDownlineRequestFields.CELL_PHONE,
        label: "Cell Phone",
        type: FormItemType.TEL,
        placeholder: "Enter Cell Phone No",
    },
    {
        field: CreateDownlineRequestFields.EMAIL,
        label: "Email",
        type: FormItemType.EMAIL,
        placeholder: "Enter Email",
    },
    {
        field: CreateDownlineRequestFields.AGENCY_NAME,
        label: "Agency Name",
        type: FormItemType.TEXT,
        placeholder: "Enter Agency Name",
    },
    {
        field: CreateDownlineRequestFields.WEBSITE,
        label: "Subdomain",
        type: FormItemType.URL,
        placeholder: "Enter Subdomain",
    },
    {
        field: CreateDownlineRequestFields.USER_TYPE,
        label: "Agency Type",
        type: FormItemType.SELECT,
        placeholder: "Select Agency Type",
        options: [],
    },
];

export const ADDITIONAL_INFORMATION_FORM_ITEMS: FormItem[] = [
    {
        field: CreateDownlineRequestFields.WRITING_NUMBER,
        label: "Writing Number",
        type: FormItemType.TEXT,
        placeholder: "Enter Writing Number",
    },
    {
        field: CreateDownlineRequestFields.AGENCY_NUMBER,
        label: "Agency Number",
        type: FormItemType.TEXT,
        placeholder: "Enter Agency Number",
    },
];
